module.exports = __webpack_public_path__ + "img/Doc14b_20030023-062_13 Sept 1979_2.5cd0ca3f.jpg";